// Formats an amount using the ISO 4217 currency code returned by the API
// (defaults to EUR for callers/data that don't carry a currency yet).
export function formatCurrency(amount, currency) {
    if (amount === undefined || amount === null || amount === '' || isNaN(amount)) {
        return '';
    }
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currency || 'EUR',
    }).format(amount);
}

export default formatCurrency;
